module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sgc-toc-title"
  }, [_vm._v("\n    Table of Contents\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cómo utilizar los diagramas del diapasón")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Problemas técnicos para principiantes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flexibilidad")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Técnicas")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes mayores")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C mayor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A mayor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G mayor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E mayor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D mayor")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes menores")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E menor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A menor")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D menor")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de 7ma dominante")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D7")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de 7ma menor")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Em7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Am7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dm7")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de 7ma mayor")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Emaj7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amaj7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dmaj7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cmaj7")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fmaj7")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de 2da suspendida")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asus2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dsus2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fsus2")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gsus2")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de 4ta suspendida")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asus4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Csus4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dsus4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Esus4")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fsus4")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Añadir 9 acordes")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cadd9")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eadd9")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fadd9")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acordes de potencia")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diagrama de notas del diapasón")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cejillas para principiantes")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Otros acordes")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G 6ta")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A dominante 13na suspendida 4ta")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D menor 7ma bemol 5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D aumentado")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A disminuido")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E disminuido")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A menor 7ma bemol 5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E menor 7ma bemol 5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A dominante 11na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A menor 11na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C mayor 13na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E menor 13na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("G menor 13na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C mayor 7ma sostenido 5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E dominante 7ma bemol 5")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E dominante 7ma suspendida 4ta")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D disminuido 7ma")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D menor / mayor 7ma")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D 6ta")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E menor añadida 9na")])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C dominante 9na suspendida 4ta")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sugerencias de canciones con acordes fáciles")]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-2"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Consejos")])])]), _vm._v(" "), _c('div', {
    staticClass: "sgc-toc-level-1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Guitar_Chords_for_Beginners#sigil_toc_id_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gracias por comprar este libro")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24614150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TOC.vue
// module id = 57
// module chunks = 0